import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    flex-wrap: wrap;
    padding: 2% 2%;
`

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70vw;
    height: 40px;
    background-color: white;
    border-radius: 10px;
`

export const PaginationBottom = styled.div`
    cursor: pointer;
    width: 15vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Carta = styled.img`
    width: 30vw;
    margin: 10px;
    border-radius: 10px;
    filter: drop-shadow(2px 1px 1px rgba(0,0,0,0.49));
`

export const List = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: start;
    margin-top: 5px;
`

export const Star = styled.div`
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor || 'rgb(234, 190, 63)'};
    display: flex;
    font-family: Roboto, sans-serif;
    font-size: ${({ fontSize }) => fontSize || '10px'};
    font-weight: bold;
    height: ${({ size }) => size || '20px'};
    justify-content: center;
    margin: 2px;
    position: absolute;
    top: 0;
    left: 0;
    transform: rotate(45deg);
    width: ${({ size }) => size || '20px'};
    z-index: 1000;

    &::before,
    &::after {
    background-color: ${({ backgroundColor }) => backgroundColor || 'rgb(234, 190, 63)'};
    content: '';
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
    }

    &::before {
    transform: rotate(30deg);
    }

    &::after {
    transform: rotate(60deg);
    }

    p {
    transform: rotate(-45deg);
    user-select: none;
    }
`;

export const Selected = styled.div`
    border: 2px solid rgb(120,170,255);
    border-radius: 10px;
    width: 34vw;
    height: calc(100% - 10px);
    position: absolute;
    top: 0;
    margin-top: 3px;
    margin-left: 3px;
`

export const IconDiv = styled.div`
    background-color: white;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    position: absolute;
    right: 0;
    margin: 3%
`